import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { bootstrapTheme } from "@/components/ThemeToggle";

// PILLAR 4 — apply persisted theme before first paint so there is no
// dark flash for daylight users.
bootstrapTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
